import gql from 'graphql-tag';

export const CHECK_SMS_BALANCE = gql`
    query {
        smsCheckBalance
    }
`;